var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiColumn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 234.287 234.288",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_32_14_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.455,56.226v37.785c0,1.016,1.147,1.843,2.56,1.843h39.141c1.412,0,2.56-0.828,2.56-1.843V56.226 c0-1.021-1.147-1.841-2.56-1.841h-39.141C130.603,54.385,129.455,55.206,129.455,56.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.782,106.909H66.653c-1.419,0-2.569,0.82-2.569,1.846v37.779c0,1.016,1.15,1.844,2.569,1.844h39.128 c1.419,0,2.569-0.828,2.569-1.844v-37.779C108.356,107.729,107.206,106.909,105.782,106.909z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.921,165.375c-11.202,0-22.419,0-33.621,0c-8.074,0-8.074,13,0,13c11.202,0,22.419,0,33.621,0 C176,178.375,176,165.375,167.921,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.921,186.387c-11.202,0-22.419,0-33.621,0c-8.074,0-8.074,12.999,0,12.999c11.202,0,22.419,0,33.621,0 C176,199.386,176,186.387,167.921,186.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.921,110.642c-11.202,0-22.419,0-33.621,0c-8.074,0-8.074,12.997,0,12.997c11.202,0,22.419,0,33.621,0 C176,123.638,176,110.642,167.921,110.642z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.921,131.652c-11.202,0-22.419,0-33.621,0c-8.074,0-8.074,12.999,0,12.999c11.202,0,22.419,0,33.621,0 C176,144.651,176,131.652,167.921,131.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.022,56.069c-11.202,0-22.407,0-33.619,0c-8.074,0-8.074,12.999,0,12.999c11.212,0,22.417,0,33.619,0 C111.106,69.068,111.106,56.069,103.022,56.069z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.022,77.082c-11.202,0-22.407,0-33.619,0c-8.074,0-8.074,12.999,0,12.999c11.212,0,22.417,0,33.619,0 C111.106,90.081,111.106,77.082,103.022,77.082z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.422,165.375c-11.212,0-22.417,0-33.619,0c-8.084,0-8.084,13,0,13c11.202,0,22.407,0,33.619,0 C108.496,178.375,108.496,165.375,100.422,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.422,186.387c-11.212,0-22.417,0-33.619,0c-8.084,0-8.084,12.999,0,12.999c11.202,0,22.407,0,33.619,0 C108.496,199.386,108.496,186.387,100.422,186.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.837,0H26.931v234.288h180.426V32.504L173.837,0z M191.762,218.683H42.53V15.6h123.269v24.75h25.958v178.333H191.762 z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiColumn);
export default __webpack_public_path__ + "static/media/multi-column.a3f44ec31a8c5ad2b215d8fd99855f9e.svg";
export { ForwardRef as ReactComponent };